import getDynamicContent from "@/action/getDynamicContent";
import DynamicPage from "@/components/DynamicPage/DynamicPage";
// import DynamicContentMain from "@/components/DynamicContent/DynamicContentMain";
import { notFound } from "next/navigation";

export const dynamic = "force-dynamic";

interface DynamicPageProps {
  dynamic_url: string[];
}

const DynamicPageRoute = async ({
  params,
}: {
  params: Promise<DynamicPageProps>;
}) => {
  const url = (await params).dynamic_url?.join("/");
  const contentData = await getDynamicContent(url);

  // console.log("contentData", contentData);

  if (!contentData) {
    notFound();
  }

  return (
    <>
      <main>
        <DynamicPage contentData={contentData} />
        {/* <DynamicContentMain contentData={contentData} /> */}
      </main>
    </>
  );
};

export default DynamicPageRoute;
